import React from 'react';

// Post-it icon with paper and pin - small version for sumário
export const PostItIcon = ({ size = 16, hasContent = false, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
    >
      {/* Paper shadow */}
      <rect 
        x="5" 
        y="7" 
        width="14" 
        height="14" 
        rx="1" 
        fill="#d4a574" 
        opacity="0.3"
        transform="rotate(-2 12 14)"
      />
      {/* Main paper */}
      <rect 
        x="4" 
        y="6" 
        width="14" 
        height="14" 
        rx="1" 
        fill={hasContent ? "#fef08a" : "#fef9c3"}
        stroke={hasContent ? "#eab308" : "#fde047"}
        strokeWidth="0.5"
      />
      {/* Paper fold corner */}
      <path 
        d="M14 16 L18 16 L18 20 Z" 
        fill={hasContent ? "#fde047" : "#fef08a"}
        stroke={hasContent ? "#eab308" : "#fde047"}
        strokeWidth="0.3"
      />
      {/* Pin head */}
      <circle 
        cx="11" 
        cy="5" 
        r="3" 
        fill={hasContent ? "#dc2626" : "#f87171"}
      />
      {/* Pin shine */}
      <circle 
        cx="10" 
        cy="4" 
        r="1" 
        fill="white" 
        opacity="0.6"
      />
      {/* Pin needle */}
      <line 
        x1="11" 
        y1="7" 
        x2="11" 
        y2="9" 
        stroke="#9ca3af" 
        strokeWidth="1"
        strokeLinecap="round"
      />
      {/* Lines on paper (if has content) */}
      {hasContent && (
        <>
          <line x1="6" y1="10" x2="14" y2="10" stroke="#d4a574" strokeWidth="0.5" opacity="0.5" />
          <line x1="6" y1="12" x2="12" y2="12" stroke="#d4a574" strokeWidth="0.5" opacity="0.5" />
          <line x1="6" y1="14" x2="13" y2="14" stroke="#d4a574" strokeWidth="0.5" opacity="0.5" />
        </>
      )}
    </svg>
  );
};

// Larger floating Post-it for editor
export const PostItFloating = ({ 
  synopsis, 
  onClose, 
  className = '' 
}) => {
  return (
    <div className={`relative ${className}`}>
      {/* Pin */}
      <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
        <svg width="24" height="28" viewBox="0 0 24 28" fill="none">
          {/* Pin head */}
          <circle cx="12" cy="8" r="7" fill="#dc2626" />
          {/* Pin shine */}
          <circle cx="9" cy="6" r="2" fill="white" opacity="0.4" />
          {/* Pin needle */}
          <line x1="12" y1="14" x2="12" y2="22" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      
      {/* Paper */}
      <div 
        className="relative bg-gradient-to-br from-yellow-100 to-yellow-200 rounded shadow-lg overflow-hidden"
        style={{
          transform: 'rotate(-1deg)',
          minWidth: '280px',
          maxWidth: '320px',
        }}
      >
        {/* Paper texture lines */}
        <div className="absolute inset-0 opacity-20">
          {[...Array(10)].map((_, i) => (
            <div 
              key={i} 
              className="border-b border-amber-400/30" 
              style={{ marginTop: `${20 + i * 20}px` }}
            />
          ))}
        </div>
        
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-6 h-6 rounded-full bg-amber-300/50 hover:bg-amber-400/50 flex items-center justify-center transition-colors"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 2L10 10M10 2L2 10" stroke="#92400e" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        
        {/* Content */}
        <div className="relative p-4 pt-6">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-sm font-medium text-amber-800">Síntese do Capítulo</span>
          </div>
          
          {synopsis ? (
            <p className="text-sm text-amber-900 whitespace-pre-wrap leading-relaxed font-serif">
              {synopsis}
            </p>
          ) : (
            <p className="text-sm text-amber-700 italic">
              Nenhuma síntese adicionada ainda.
              <br />
              <span className="text-xs">Vá ao Sumário para adicionar uma nota.</span>
            </p>
          )}
        </div>
        
        {/* Folded corner */}
        <div 
          className="absolute bottom-0 right-0 w-8 h-8"
          style={{
            background: 'linear-gradient(135deg, transparent 50%, #fde047 50%)',
          }}
        />
      </div>
    </div>
  );
};

export default PostItIcon;
